import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuUpdatePayload,
	IActionMenuUpdatePayloadDone,
	IActionMenuUpdatePayloadError,
} from './types';

export const menuUpdate = actionCreatorAsync<
	IActionMenuUpdatePayload,
	IActionMenuUpdatePayloadDone,
	IActionMenuUpdatePayloadError
>(
	'menuUpdate',
	async (params) => {
		const { menu } = params;
		const { id, ...body } = menu;
		const { data } = await Api.menu.update({
			params: { id },
			body,
		});

		return data;
	},
);
